<template>
    <v-container fluid grid-list-sm>
        <v-subheader>
            <v-icon class="mr-1" color="teal">format_list_bulleted</v-icon>
            待办事项
        </v-subheader>
        <v-divider color="lightgrey"/>
        <v-layout row wrap>
            <v-flex xs6 sm3 md2 lg2>
                <v-btn flat large to="/proj/project?statusId=await">
                    <v-badge overlap color="red">
                        <template v-slot:badge>
                            <span>{{pendingProjects.total}}</span>
                        </template>
                        <v-icon large color="primary">description</v-icon>
                    </v-badge>
                    立项审核
                </v-btn>
            </v-flex>

          <v-flex xs6 sm3 md2 lg2>
            <v-btn flat large
                   to="/ol-ctra/index?statusId=org_await">
              <v-badge color="red" overlap>
                <template v-slot:badge>
                  <span>{{pendingOlCtra.total}}</span>
                </template>
                <v-icon large color="orange">forum</v-icon>
              </v-badge>
              待审核合同
            </v-btn>
          </v-flex>

          <v-flex xs6 sm3 md2 lg2>
            <v-btn flat large
                   to="/agmt/index?statusId=org_await">
              <v-badge color="red" overlap>
                <template v-slot:badge>
                  <span>{{pendingAgmt.total}}</span>
                </template>
                <v-icon large color="orange">domain</v-icon>
              </v-badge>
              待审核合作协议
            </v-btn>
          </v-flex>

          <v-flex xs6 sm3 md2 lg2>
            <v-btn flat large
                   to="/seal/index?statusId=org_await">
              <v-badge color="red" overlap>
                <template v-slot:badge>
                  <span>{{pendingSeal.total}}</span>
                </template>
                <v-icon large color="orange">domain</v-icon>
              </v-badge>
              待审核用印申请
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12 sm6 md6 lg8>
                <v-subheader>
                    <v-icon class="mr-1" color="teal">reply_all</v-icon>
                    快捷通道
                </v-subheader>
                <v-divider color="lightgrey"/>
                <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                        <v-flex xs2>
                            <v-card flat to="/proj/project">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large color="blue">fas fa-file-alt</v-icon>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    项目管理
                                    <v-spacer/>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex xs2>
                            <v-card flat to="/proj/create">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large color="orange">fas fa-edit</v-icon>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    项目立项
                                    <v-spacer/>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex xs2>
                            <v-card flat to="/web/article">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large color="green">fas fa-comments</v-icon>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    通知公告
                                    <v-spacer/>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex xs2>
                            <v-card flat to="/proj/rept/index">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large color="purple">fas fa-chart-pie</v-icon>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    项目统计
                                    <v-spacer/>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex xs2>
                            <v-card flat to="#">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large color="amber darken-4">fas fa-calculator</v-icon>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    项目绩效
                                    <v-spacer/>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex xs2>
                            <v-card flat to="#">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large color="light-green darken-4">fa fa-paperclip</v-icon>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    项目附件
                                    <v-spacer/>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                    </v-layout>
                </v-container>
            </v-flex>

            <!--  科研规模年度统计 -->
            <v-flex xs12 sm6 md6 lg4>
                <v-subheader>
                    <v-icon class="mr-1" color="teal">insert_chart_outlined</v-icon>
                    项目统计
                </v-subheader>
                <v-divider color="lightgrey"/>
                <v-card flat>
                    <v-card-text>
                        <five-year-by-type/>
                    </v-card-text>
                </v-card>
            </v-flex>

        </v-layout>

    </v-container>
</template>
<script>

    import FiveYearByType from '../proj/rept/FiveYearByType'

    const pendingProjUrl = '/api/proj/project';
    const pendingOlCtraUrl = '/api/ol-ctra/contract';
    const pendingAgmt = '/api/agmt/agreement';
    const pendingSealUri =  '/api/seal/quick';

    export default {
        components: {
            FiveYearByType
        },
        data() {
            return {
                pendingProjects: {total: '?'},
                pendingOlCtra: {total: '?'},
                pendingAgmt: {total: '?'},
                pendingSeal: {total: '?'}
            }
        },
        created() {
            // 加载审核状态
          this.axios.all([
            this.axios.get(pendingProjUrl, {params: {statusId: 'await', page: 0, limit: 1,}}),
            this.axios.get(pendingOlCtraUrl, {params: {statusId: 'org_await', page: 0, limit: 1,}}),
            this.axios.get(pendingAgmt, {params: {statusId: 'org_await', page: 0, limit: 1,}}),
            this.axios.get(pendingSealUri, {params: {statusId: 'org_await', page: 0, limit: 1,}})
          ]).then(
              this.axios.spread((rspProj ,rspOlCtra, rspAgmt, rspSeal) => {
                    this.pendingProjects = rspProj.data;
                    this.pendingOlCtra = rspOlCtra.data;
                    this.pendingAgmt = rspAgmt.data
                    this.pendingSeal = rspSeal.data
                    }
                )
          )
        },
    }
</script>
<style>
    span.v-badge__badge {
        width: auto;
        min-width: 22px;
        border-radius: 13px;
    }
</style>
